import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeadingH2, Subheading as SubheadingBase } from "components/misc/Headings.js";
import TeamIllustrationSrc from "images/chart-lp.png";
import Content from "_content/SeoContent.js";

const Container = tw.div`relative pt-16`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto pt-12 pb-20 md:pb-24 items-center`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-6/12 flex-shrink-0 relative md:-ml-12 md:mr-12`;
const TextColumn = styled(Column)(props => [
  tw`md:w-6/12`,
  props.textOnLeft ? tw`md:mr-12 lg:mr-16 md:order-first` : tw`md:ml-12 lg:ml-16 md:order-last`
]);

const Image = styled.img(props => [
  props.imageRounded && tw`rounded`,
  props.imageBorder && tw`border`,
  props.imageShadow && tw`shadow`
]);

const TextContent = tw.div`lg:py-8 text-left`;

const Heading = tw(
  SectionHeadingH2
)`mt-4 font-black text-left leading-tight text-gray-800`;
const Description = tw.p`mt-8 text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`;


export default ({
  imageSrc = TeamIllustrationSrc,
  imageRounded = true,
  imageBorder = false,
  imageShadow = false,
  textOnLeft = false
}) => {
  
  const [urlPath, setUrlPath] = useState("");
  let location = useLocation()

  useEffect(() => {
    let addSlash = !location.pathname.endsWith('/')
    const pathRef = addSlash ? location.pathname + '/' : location.pathname
    if (Object.keys(Content.pages).includes(pathRef)){
      setUrlPath(pathRef)
    }
  }, [location]);

  const block1Heading = Content.pages[urlPath].block1Heading || "";
  const block1Content = Content.pages[urlPath].block1Content || "";
  const block1Alt = Content.pages[urlPath].block1Alt || "";

  return (
    <Container >
      <TwoColumn>
        <ImageColumn>
          <Image src={imageSrc} imageBorder={imageBorder} imageShadow={imageShadow} imageRounded={imageRounded} alt={block1Alt} loading="lazy"/>
        </ImageColumn>
        <TextColumn textOnLeft={textOnLeft}>
          <TextContent >
            <Heading>{block1Heading}</Heading>
            <Description className="display-linebreak">{block1Content}</Description>
          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};
